import React from 'react';
import VstComponent from './VstComponent';
import VstTabBar from './VstTabBar';
import VstTabPanels from './VstTabPanels';
import VstTab from './VstTab';

export default class VstTabs extends VstComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: props.activeIndex
    }
  }

  render() {
    const { activeIndex } = this.state;
    const children = React.Children.map(this.props.children, child => {
      if (child.type.displayName === "VstTabPanels") {
        return React.cloneElement(child, { activeIndex });
      } else if (child.type.displayName === "VstTabBar") {
        return React.cloneElement(child, {
          activeIndex,
          onClick: activeIndex => {
            this.setState({ activeIndex });
          }
        });
      } else {
        return child;
      }
    });

    return (
      <div>{children}</div>
    );
  }
}

VstTabs.defaultProps = {
  activeIndex: 0
}

VstTabs.Bar = VstTabBar;
VstTabs.Bar.displayName = "VstTabBar"
VstTabs.Panels = VstTabPanels;
VstTabs.Panels.displayName = "VstTabPanels"
VstTabs.Tab = VstTab;